import api from '../api'; // Assuming 'api' is your configured Axios instance

/**
 * Fetch all coupons available.
 *
 * @return {Promise<Object>} - The response from the API.
 * @throws {Error} - If the request fails.
 */
const getCoupons = async () => {
  // Define your API endpoint
  const endpoint = process.env.REACT_APP_API_ENDPOINT + "/api/coupon/getAllCoupons";

  try {
    // Send GET request to the server
    const response = await api.get(endpoint);

    // Check the response code from API and throw error if it's not SUCCESS
    // if (response.data.Code !== '000') {
    //   throw new Error('Failed to retrieve coupons: ' + response.data.Message);
    // }

    // Return the data from the response
    return response.data;

  } catch (error) {
    // Log and rethrow the error to be handled by the calling code
    console.error('Error while fetching coupons:', error);
    throw error;
  }
};

export default getCoupons;
